// https://davidwalsh.name/javascript-debounce-function
export function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function getCSRFToken() {
  return document.querySelector('meta[name="csrf-token"]').content;
}

export function kebabFromCamel(input) {
  return input.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
